import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=2f5dc003&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=2f5dc003&lang=scss"
import style1 from "./index copy.vue?vue&type=style&index=1&id=2f5dc003&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dc003",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5dc003')) {
      api.createRecord('2f5dc003', component.options)
    } else {
      api.reload('2f5dc003', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=2f5dc003&scoped=true", function () {
      api.rerender('2f5dc003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index copy.vue"
export default component.exports